/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ComposedGoodsVo } from './ComposedGoodsVo';
import {
    ComposedGoodsVoFromJSON,
    ComposedGoodsVoFromJSONTyped,
    ComposedGoodsVoToJSON,
    ComposedGoodsVoToJSONTyped,
} from './ComposedGoodsVo';

/**
 * 
 * @export
 * @interface ResponseComposedGoodsVo
 */
export interface ResponseComposedGoodsVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseComposedGoodsVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseComposedGoodsVo
     */
    message?: string;
    /**
     * 
     * @type {ComposedGoodsVo}
     * @memberof ResponseComposedGoodsVo
     */
    data?: ComposedGoodsVo;
}

/**
 * Check if a given object implements the ResponseComposedGoodsVo interface.
 */
export function instanceOfResponseComposedGoodsVo(value: object): value is ResponseComposedGoodsVo {
    return true;
}

export function ResponseComposedGoodsVoFromJSON(json: any): ResponseComposedGoodsVo {
    return ResponseComposedGoodsVoFromJSONTyped(json, false);
}

export function ResponseComposedGoodsVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseComposedGoodsVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ComposedGoodsVoFromJSON(json['data']),
    };
}

export function ResponseComposedGoodsVoToJSON(json: any): ResponseComposedGoodsVo {
    return ResponseComposedGoodsVoToJSONTyped(json, false);
}

export function ResponseComposedGoodsVoToJSONTyped(value?: ResponseComposedGoodsVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': ComposedGoodsVoToJSON(value['data']),
    };
}

